const cardRegistrationTranslations = {
  es_MX: {
    breadcrumbs: {
      title: 'Configuración de Pagos Automáticos',
      description: 'Selecciona tu programa y configura tu método de pago para el pago automático de las cuotas'
    },
    view: {
      loading: 'Cargando...',
      selectCareerQuestion: '¿Qué carrera o curso quieres pagar?',
      noCareerFound: 'No se encontraron carreras para seleccionar. Si el problema persiste, contacta a soporte.',
      registerCardButton: 'Registrar tarjeta',
      updateCardButton: 'Actualizar datos de tarjeta',
      cancelSubscriptionButton: 'Cancelar suscripción',
      successMessage: '¡Tarjeta registrada exitosamente!',
      registerAnotherCard: 'Registrar otra tarjeta',
      selectCareerError: 'Por favor, selecciona una carrera para registrar la tarjeta.',
      cancelSubscriptionTitle: 'Cancelar Suscripción',
      cancelSubscriptionConfirmation: '¿Estás seguro que deseas cancelar tu suscripción de pago automático? Esta acción no se puede deshacer.',
      cancelButton: 'Cancelar',
      confirmButton: 'Confirmar',
      cardRegistrationModalTitle: 'Registro de Tarjeta',
      closeButton: 'Cerrar',
      successTitle: '¡Operación Exitosa!',
      errorTitle: 'Error',
      subscriptionCancelledMessage: 'Tu suscripción ha sido cancelada exitosamente.',
      noActiveSubscription: 'No podés cancelar porque no tenés una suscripción activa asociada a tu cuenta.',
      cardInfoTitle: 'Tarjeta registrada',
      cardInfoBrand: 'Marca',
      cardInfoLastFour: 'Últimos 4 dígitos',
      errorFetchingCardDetails: 'Error al obtener los detalles de la tarjeta. Por favor intenta de nuevo más tarde.',
      active: 'Activa',
      cardRegistrationTitle: 'Ingresa tu tarjeta de forma protegida',
      cardRegistrationDescription: 'Te redirigiremos a la plataforma de pagos Flywire para registrar tu tarjeta de forma segura en solo unos minutos.',
      bankEncryption: 'Encriptación bancaria',
      pciDssCertified: 'PCI DSS certificado',
      poweredByFlywire: 'Powered by Flywire • Procesador de pagos global'
    },
    title: 'Registro de Tarjeta de Crédito',
    selectCareerDescription: 'Por favor selecciona la carrera para la cual quieres registrar una tarjeta de crédito para pagos automáticos.',
    selectCareer: 'Seleccionar Carrera',
    continue: 'Continuar',
    success: '¡Tu tarjeta de crédito ha sido registrada exitosamente para pagos automáticos!',
    errorFetchingCareers: 'Error al obtener las carreras. Por favor intenta de nuevo más tarde.',
    errorFetchingStudentData: 'Error al obtener los datos del estudiante. Por favor intenta de nuevo más tarde.',
    errorCreatingCheckout: 'Error al crear la sesión de checkout. Por favor intenta de nuevo más tarde.',
    invalidCheckoutSession: 'Sesión de checkout inválida. Por favor intenta de nuevo.',
    errorProcessingCard: 'Error al procesar la tarjeta de crédito. Por favor intenta de nuevo.',
    errorConfirmingCard: 'Error al confirmar el registro de la tarjeta. Por favor intenta de nuevo.'
  },
  es_CL: {
    breadcrumbs: {
      title: 'Configuración de Pagos Automáticos',
      description: 'Selecciona tu programa y configura tu método de pago para el pago automático de las cuotas'
    },
    view: {
      loading: 'Cargando...',
      selectCareerQuestion: '¿Qué carrera o curso quieres pagar?',
      noCareerFound: 'No se encontraron carreras para seleccionar. Si el problema persiste, contacta a soporte.',
      registerCardButton: 'Registrar tarjeta',
      updateCardButton: 'Actualizar datos de tarjeta',
      cancelSubscriptionButton: 'Cancelar suscripción',
      successMessage: '¡Tarjeta registrada exitosamente!',
      registerAnotherCard: 'Registrar otra tarjeta',
      selectCareerError: 'Por favor, selecciona una carrera para registrar la tarjeta.',
      cancelSubscriptionTitle: 'Cancelar Suscripción',
      cancelSubscriptionConfirmation: '¿Estás seguro que deseas cancelar tu suscripción de pago automático? Esta acción no se puede deshacer.',
      cancelButton: 'Cancelar',
      confirmButton: 'Confirmar',
      cardRegistrationModalTitle: 'Registro de Tarjeta',
      closeButton: 'Cerrar',
      successTitle: '¡Operación Exitosa!',
      errorTitle: 'Error',
      subscriptionCancelledMessage: 'Tu suscripción ha sido cancelada exitosamente.',
      noActiveSubscription: 'No podés cancelar porque no tenés una suscripción activa asociada a tu cuenta.',
      cardInfoTitle: 'Tarjeta registrada',
      cardInfoBrand: 'Marca',
      cardInfoLastFour: 'Últimos 4 dígitos',
      errorFetchingCardDetails: 'Error al obtener los detalles de la tarjeta. Por favor intenta de nuevo más tarde.',
      active: 'Activa',
      cardRegistrationTitle: 'Ingresa tu tarjeta de forma protegida',
      cardRegistrationDescription: 'Te redirigiremos a la plataforma de pagos Flywire para registrar tu tarjeta de forma segura en solo unos minutos.',
      bankEncryption: 'Encriptación bancaria',
      pciDssCertified: 'PCI DSS certificado',
      poweredByFlywire: 'Powered by Flywire • Procesador de pagos global'
    },
    title: 'Registro de Tarjeta de Crédito',
    selectCareerDescription: 'Por favor selecciona la carrera para la cual quieres registrar una tarjeta de crédito para pagos automáticos.',
    selectCareer: 'Seleccionar Carrera',
    continue: 'Continuar',
    success: '¡Tu tarjeta de crédito ha sido registrada exitosamente para pagos automáticos!',
    errorFetchingCareers: 'Error al obtener las carreras. Por favor intenta de nuevo más tarde.',
    errorFetchingStudentData: 'Error al obtener los datos del estudiante. Por favor intenta de nuevo más tarde.',
    errorCreatingCheckout: 'Error al crear la sesión de checkout. Por favor intenta de nuevo más tarde.',
    invalidCheckoutSession: 'Sesión de checkout inválida. Por favor intenta de nuevo.',
    errorProcessingCard: 'Error al procesar la tarjeta de crédito. Por favor intenta de nuevo.',
    errorConfirmingCard: 'Error al confirmar el registro de la tarjeta. Por favor intenta de nuevo.'
  },
  es_PE: {
    breadcrumbs: {
      title: 'Configuración de Pagos Automáticos',
      description: 'Selecciona tu programa y configura tu método de pago para el pago automático de las cuotas'
    },
    view: {
      loading: 'Cargando...',
      selectCareerQuestion: '¿Qué carrera o curso quieres pagar?',
      noCareerFound: 'No se encontraron carreras para seleccionar. Si el problema persiste, contacta a soporte.',
      registerCardButton: 'Registrar tarjeta',
      updateCardButton: 'Actualizar datos de tarjeta',
      cancelSubscriptionButton: 'Cancelar suscripción',
      successMessage: '¡Tarjeta registrada exitosamente!',
      registerAnotherCard: 'Registrar otra tarjeta',
      selectCareerError: 'Por favor, selecciona una carrera para registrar la tarjeta.',
      cancelSubscriptionTitle: 'Cancelar Suscripción',
      cancelSubscriptionConfirmation: '¿Estás seguro que deseas cancelar tu suscripción de pago automático? Esta acción no se puede deshacer.',
      cancelButton: 'Cancelar',
      confirmButton: 'Confirmar',
      cardRegistrationModalTitle: 'Registro de Tarjeta',
      closeButton: 'Cerrar',
      successTitle: '¡Operación Exitosa!',
      errorTitle: 'Error',
      subscriptionCancelledMessage: 'Tu suscripción ha sido cancelada exitosamente.',
      noActiveSubscription: 'No podés cancelar porque no tenés una suscripción activa asociada a tu cuenta.',
      cardInfoTitle: 'Tarjeta registrada',
      cardInfoBrand: 'Marca',
      cardInfoLastFour: 'Últimos 4 dígitos',
      errorFetchingCardDetails: 'Error al obtener los detalles de la tarjeta. Por favor intenta de nuevo más tarde.',
      active: 'Activa',
      cardRegistrationTitle: 'Ingresa tu tarjeta de forma protegida',
      cardRegistrationDescription: 'Te redirigiremos a la plataforma de pagos Flywire para registrar tu tarjeta de forma segura en solo unos minutos.',
      bankEncryption: 'Encriptación bancaria',
      pciDssCertified: 'PCI DSS certificado',
      poweredByFlywire: 'Powered by Flywire • Procesador de pagos global'
    },
    title: 'Registro de Tarjeta de Crédito',
    selectCareerDescription: 'Por favor selecciona la carrera para la cual quieres registrar una tarjeta de crédito para pagos automáticos.',
    selectCareer: 'Seleccionar Carrera',
    continue: 'Continuar',
    success: '¡Tu tarjeta de crédito ha sido registrada exitosamente para pagos automáticos!',
    errorFetchingCareers: 'Error al obtener las carreras. Por favor intenta de nuevo más tarde.',
    errorFetchingStudentData: 'Error al obtener los datos del estudiante. Por favor intenta de nuevo más tarde.',
    errorCreatingCheckout: 'Error al crear la sesión de checkout. Por favor intenta de nuevo más tarde.',
    invalidCheckoutSession: 'Sesión de checkout inválida. Por favor intenta de nuevo.',
    errorProcessingCard: 'Error al procesar la tarjeta de crédito. Por favor intenta de nuevo.',
    errorConfirmingCard: 'Error al confirmar el registro de la tarjeta. Por favor intenta de nuevo.'
  },
  es: {
    breadcrumbs: {
      title: 'Configuración de Pagos Automáticos',
      description: 'Selecciona tu programa y configura tu método de pago para el pago automático de las cuotas'
    },
    view: {
      loading: 'Cargando...',
      selectCareerQuestion: '¿Qué carrera o curso quieres pagar?',
      noCareerFound: 'No se encontraron carreras para seleccionar. Si el problema persiste, contacta a soporte.',
      registerCardButton: 'Registrar tarjeta',
      updateCardButton: 'Actualizar datos de tarjeta',
      cancelSubscriptionButton: 'Cancelar suscripción',
      successMessage: '¡Tarjeta registrada exitosamente!',
      registerAnotherCard: 'Registrar otra tarjeta',
      selectCareerError: 'Por favor, selecciona una carrera para registrar la tarjeta.',
      cancelSubscriptionTitle: 'Cancelar Suscripción',
      cancelSubscriptionConfirmation: '¿Estás seguro que deseas cancelar tu suscripción de pago automático? Esta acción no se puede deshacer.',
      cancelButton: 'Cancelar',
      confirmButton: 'Confirmar',
      cardRegistrationModalTitle: 'Registro de Tarjeta',
      closeButton: 'Cerrar',
      successTitle: '¡Operación Exitosa!',
      errorTitle: 'Error',
      subscriptionCancelledMessage: 'Tu suscripción ha sido cancelada exitosamente.',
      noActiveSubscription: 'No podés cancelar porque no tenés una suscripción activa asociada a tu cuenta.',
      cardInfoTitle: 'Tarjeta registrada',
      cardInfoBrand: 'Marca',
      cardInfoLastFour: 'Últimos 4 dígitos',
      errorFetchingCardDetails: 'Error al obtener los detalles de la tarjeta. Por favor intenta de nuevo más tarde.',
      active: 'Activa',
      cardRegistrationTitle: 'Ingresa tu tarjeta de forma protegida',
      cardRegistrationDescription: 'Te redirigiremos a la plataforma de pagos Flywire para registrar tu tarjeta de forma segura en solo unos minutos.',
      bankEncryption: 'Encriptación bancaria',
      pciDssCertified: 'PCI DSS certificado',
      poweredByFlywire: 'Powered by Flywire • Procesador de pagos global'
    },
    title: 'Registro de Tarjeta de Crédito',
    selectCareerDescription: 'Por favor selecciona la carrera para la cual quieres registrar una tarjeta de crédito para pagos automáticos.',
    selectCareer: 'Seleccionar Carrera',
    continue: 'Continuar',
    success: '¡Tu tarjeta de crédito ha sido registrada exitosamente para pagos automáticos!',
    errorFetchingCareers: 'Error al obtener las carreras. Por favor intenta de nuevo más tarde.',
    errorFetchingStudentData: 'Error al obtener los datos del estudiante. Por favor intenta de nuevo más tarde.',
    errorCreatingCheckout: 'Error al crear la sesión de checkout. Por favor intenta de nuevo más tarde.',
    invalidCheckoutSession: 'Sesión de checkout inválida. Por favor intenta de nuevo.',
    errorProcessingCard: 'Error al procesar la tarjeta de crédito. Por favor intenta de nuevo.',
    errorConfirmingCard: 'Error al confirmar el registro de la tarjeta. Por favor intenta de nuevo.'
  },
  en: {
    breadcrumbs: {
      title: 'Payment Configuration',
      description: 'Select your program and configure your payment method for monthly payments'
    },
    view: {
      loading: 'Loading...',
      selectCareerQuestion: 'Which career or course do you want to pay for?',
      noCareerFound: 'No careers found to select. If the problem persists, contact support.',
      registerCardButton: 'Register card',
      updateCardButton: 'Update card data',
      cancelSubscriptionButton: 'Cancel subscription',
      successMessage: 'Card successfully registered!',
      registerAnotherCard: 'Register another card',
      selectCareerError: 'Please select a career to register the card.',
      cancelSubscriptionTitle: 'Cancel Subscription',
      cancelSubscriptionConfirmation: 'Are you sure you want to cancel your automatic payment subscription? This action cannot be undone.',
      cancelButton: 'Cancel',
      confirmButton: 'Confirm',
      cardRegistrationModalTitle: 'Credit Card Registration',
      closeButton: 'Close',
      successTitle: 'Operation Successful!',
      errorTitle: 'Error',
      subscriptionCancelledMessage: 'Your subscription has been successfully cancelled.',
      noActiveSubscription: 'You cannot cancel because you do not have an active subscription associated with your account.',
      cardInfoTitle: 'Registered card',
      cardInfoBrand: 'Brand',
      cardInfoLastFour: 'Last 4 digits',
      errorFetchingCardDetails: 'Error fetching card details. Please try again later.',
      active: 'Active',
      cardRegistrationTitle: 'Enter Your Card Securely',
      cardRegistrationDescription: 'We will redirect you to the Flywire payment platform to register your card securely in just a few minutes.',
      bankEncryption: 'Bank encryption',
      pciDssCertified: 'PCI DSS certified',
      poweredByFlywire: 'Powered by Flywire • Global payment processor'
    },
    title: 'Credit Card Registration',
    selectCareerDescription: 'Please select the career for which you want to register a credit card for automatic payments.',
    selectCareer: 'Select Career',
    continue: 'Continue',
    success: 'Your credit card has been successfully registered for automatic payments.',
    errorFetchingCareers: 'Error fetching careers. Please try again later.',
    errorFetchingStudentData: 'Error fetching student data. Please try again later.',
    errorCreatingCheckout: 'Error creating checkout session. Please try again later.',
    invalidCheckoutSession: 'Invalid checkout session. Please try again.',
    errorProcessingCard: 'Error processing credit card. Please try again.',
    errorConfirmingCard: 'Error confirming card registration. Please try again.'
  }
};

export default cardRegistrationTranslations; 